import moment from "moment";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Button, ButtonGroup, Col, Input, Label, Modal, ModalBody, Row, Spinner } from "@/Components/ui";;

export default function ReceiptModal({
    show, onCloseClick,
    // startDate,
    // endDate,
    // subdomain,
    loading,
    receiptData,
    refetch,
    onStartJob
}) {
    return (
        <Modal isOpen={show} onClose={onCloseClick} centered={true}>
            <ModalBody className="py-3 px-5" >
                <div className="mt-2 d-flex justify-content-end gap-2">
                    <Button
                        type="button"
                        
                        onClick={onStartJob}
                     color="success">
                        파일 생성하기
                    </Button>

                    {loading ? (
                        <Spinner color="primary" />
                    ) : <Button type="button"  onClick={refetch} color="light">
                        <i className="mdi mdi-refresh fs-18"></i>
                    </Button>}
                </div>
                <Row className="mt-4">
                    <Col lg={12} xl={6}>
                        {receiptData && receiptData.length > 0 ? (
                            <div>
                                {receiptData.map((receipt, index) => {
                                    let badgeColor = "badge-outline-success";
                                    let status = "완료";
                                    if (receipt.status === "wait") {
                                        badgeColor = "badge-outline-warning";
                                        status = "대기";
                                    } else if (receipt.status === "failed") {
                                        badgeColor = "badge-outline-danger";
                                        status = "실패";
                                    } else if (receipt.status === "canceled") {
                                        badgeColor = "badge-outline-danger";
                                        status = "취소";
                                    } else if (receipt.status === "started") {
                                        badgeColor = "badge-outline-info";
                                        status = "처리중";
                                    }

                                    return (
                                        <div key={index} style={{
                                            padding: "10px",
                                            border: "1px solid #d9d9d9",
                                            borderRadius: "5px",
                                            marginBottom: "10px",
                                            width: "400px",
                                            display: "flex",
                                            flexDirection: "row",
                                            gap: "5px",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                        }}>
                                            <div>
                                                {receipt.id}
                                                {/* <span>{receipt.subdomain}{receipt.start_date}{receipt.end_date}</span> */}
                                            </div>
                                            <div>생성일: {moment(receipt.created_at).format("YYYY-MM-DD HH:mm")}</div>
                                            <div className="status-badge badge badge-outline-success fs-14 py-2">{status}</div>
                                            {/* <div>{receipt.file}</div> */}
                                            {receipt.file ? <Button type="button"  onClick={() => window.open(receipt.file)} color="secondary" size="sm" className="py-2">
                                                다운로드
                                            </Button> : <div></div>}
                                        </div>
                                    )
                                })}
                            </div>
                        ) : (
                            <div className="text-center">No data found</div>
                        )}
                    </Col>
                </Row>
                <Row className="mt-4">
                    <div>
                        <p>각 결제 건에 대한 PG사(토스) 내역을 대조하여 액셀 파일(csv)을 생성합니다.<br />
                            파일 생성에 약 10분 정도 소요될 수 있습니다.</p>
                    </div>
                </Row>
                <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
                    <Button type="button"  data-bs-dismiss="modal" onClick={onCloseClick} color="light">
                        닫기
                    </Button>
                </div>
            </ModalBody>
        </Modal>
    );
}
